export default __webpack_public_path__ + "locales/tr/PaymentsEnterprise.json?hash=d8ad5a012c13bc08b5a58ad1994d8d12";